import { hashToCollection, formattedCues, } from '../../../Shared/index';
import { getQuestionConceptUID } from '../getQuestionConceptUID';

export function getConceptResultsForFillInTheBlanks(question) {
  const prompt = question.prompt.replace(/(<([^>]+)>)/ig, '').replace(/&nbsp;/ig, '');
  const answer = question.attempts[0].response.text;
  const questionConceptUID = getQuestionConceptUID(question);
  let conceptResults = [];
  if (question.attempts[0].response) {
    const conceptResultObject = question.attempts[0].response.conceptResults || question.attempts[0].response.concept_results
    conceptResults = hashToCollection(conceptResultObject) || [];
  } else {
    conceptResults = [];
  }
  if (conceptResults.length === 0) {
    conceptResults = [{
      conceptUID: questionConceptUID,
      correct: false,
    }];
  }
  let directions = question.instructions || 'Fill in the blanks.';
  if (question.cues && question.cues[0] !== '') {
    directions += ` ${formattedCues(question.cues)}`;
  }
  return conceptResults.map(conceptResult => ({
    concept_uid: conceptResult.conceptUID,
    question_type: 'fill-in-the-blanks',
    metadata: {
      correct: conceptResult.correct ? 1 : 0,
      directions,
      prompt,
      answer,
      question_uid: question.key,
      question_concept_uid: questionConceptUID,
      cues: question.cues?.filter(Boolean)
    },
  }));
}
